'use strict';
angular.module('mean.bids').factory('bidPlanCodeService', ['$q', '$filter',
    function($q, $filter) {

        var getSinglePlan = function(single) {
            var bid_menu = [];
            
            var elevations = single.elevations.split(',');

            if(elevations.length > 1) {
                for(var j=0; j<elevations.length; j++) {
                    var subitem = elevations[j];
                    subitem = subitem.replace(/\s/g, '');
                    bid_menu.push({
                        number: single.number,
                        elevations: subitem.toUpperCase()
                    });
                }
            } else {
                var subitem = elevations[0].replace(/\s/g, '');
                bid_menu.push({
                    number: single.number,
                    elevations: subitem.toUpperCase(),
                    quantity: single.quantity
                });
            }

            return bid_menu;
        };

        return {
            getSinglePlan: getSinglePlan
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bid-plan-code-service.js